import { useState } from "react";
import { Link } from "react-router-dom";
import SiteLayout from "@/components/feature/SiteLayout";
import usePageMeta from "@/hooks/usePageMeta";
import DownloadModal from "@/components/base/DownloadModal";
import { movies } from "@/mocks/movies";
import type { WatchApp } from "@/mocks/movies";
import HeroCarousel from "./components/HeroCarousel";
import CategoryEntries from "./components/CategoryEntries";
import MovieGridSection from "./components/MovieGridSection";
import AppShowcase from "./components/AppShowcase";
import SiteIntro from "./components/SiteIntro";

export default function Home() {
  const [downloadApp, setDownloadApp] = useState<WatchApp | null>(null);

  usePageMeta({
    title: "看片免费app网站 - 高清影视资源推荐与应用下载平台",
    description:
      "看片免费app网站致力于为用户提供丰富的高清影视资源和实用的看片应用推荐，涵盖电影、电视剧等多种类别，满足用户在线观看与下载需求。",
    keywords:
      "看片免费app网站,看片app,免费影视,影视资源,在线电影,电视剧观看,影视下载,高清电影",
  });

  const slides = movies.filter((movie) => movie.featured && movie.banner);
  const hotMovies = movies
    .filter((movie) => movie.type === "电影")
    .sort((a, b) => b.rating - a.rating)
    .slice(0, 8);
  const hotSeries = movies
    .filter((movie) => movie.type === "电视剧")
    .sort((a, b) => b.rating - a.rating)
    .slice(0, 8);
  const latest = [...movies]
    .sort((a, b) => b.year - a.year)
    .slice(0, 6);

  return (
    <SiteLayout>
      <HeroCarousel slides={slides} />
      <CategoryEntries />

      <section className="w-full max-w-page mx-auto px-4 md:px-8 mt-10">
        <div className="flex flex-col md:flex-row md:items-center gap-3 rounded-lg border border-background-200/80 bg-background-50 px-4 py-3">
          <span className="inline-flex items-center gap-1.5 text-xs font-medium text-accent-700 whitespace-nowrap">
            <i className="ri-flashlight-line"></i>
            最近更新
          </span>
          <div className="flex-1 flex items-center gap-4 overflow-x-auto no-scrollbar">
            {latest.map((movie) => (
              <Link
                key={movie.id}
                to={`/detail/${movie.id}`}
                className="text-xs text-foreground-600 hover:text-primary-600 transition-colors whitespace-nowrap"
              >
                {movie.title}
                <span className="text-foreground-400 ml-1">{movie.year}</span>
              </Link>
            ))}
          </div>
          <Link to="/category/电影" className="text-xs text-foreground-500 hover:text-primary-600 whitespace-nowrap">
            更多更新
            <i className="ri-arrow-right-s-line align-middle"></i>
          </Link>
        </div>
      </section>

      <MovieGridSection
        eyebrow="Hot Movies"
        title="热门电影"
        description="按站内评分排序，本周讨论度最高的八部电影。"
        moreTo="/category/电影"
        items={hotMovies}
      />

      <MovieGridSection
        eyebrow="Hot Series"
        title="热门电视剧"
        description="从都市悬疑到古装探案，正在被追更的剧集都在这里。"
        moreTo="/category/电视剧"
        items={hotSeries}
      />

      <AppShowcase onDownload={setDownloadApp} />

      <SiteIntro />

      <DownloadModal
        open={Boolean(downloadApp)}
        appName={downloadApp?.name ?? ""}
        onClose={() => setDownloadApp(null)}
      />
    </SiteLayout>
  );
}